export const NAV = {
  logo: "nav-logo",
  home: "nav-home",
  services: "nav-services",
  gallery: "nav-gallery",
  about: "nav-about",
  contact: "nav-contact",
  mobileToggle: "nav-mobile-toggle",
  quoteCta: "nav-quote-cta",
};

export const HOME = {
  emergentLink: "home-emergent-link",
  hero: "home-hero",
  heroCta: "home-hero-cta",
  heroCallCta: "home-hero-call-cta",
  servicesPreview: "home-services-preview",
  serviceCard: (slug) => `home-service-card-${slug}`,
  testimonialsSection: "home-testimonials",
  ctaBanner: "home-cta-banner",
};

export const SERVICES_PAGE = {
  root: "services-root",
  row: (slug) => `services-row-${slug}`,
};

export const GALLERY_PAGE = {
  root: "gallery-root",
  item: (id) => `gallery-item-${id}`,
  filterBtn: (key) => `gallery-filter-${key}`,
};

export const ABOUT_PAGE = {
  root: "about-root",
};

export const CONTACT_PAGE = {
  root: "contact-root",
  form: "contact-form",
  name: "contact-name",
  email: "contact-email",
  phone: "contact-phone",
  service: "contact-service",
  address: "contact-address",
  message: "contact-message",
  submit: "contact-submit",
  success: "contact-success",
  error: "contact-error",
};

export const FOOTER = {
  root: "footer-root",
};
